import axios from "axios";
import { API } from "@/lib/api";

/** Een groep of selectie opruimvoorstellen in een keer. Herstelbatch b (GO Frank 23 okt).
 *
 *  Eerst een token voor alle open voorstellen in `ids`, dan het besluit. De server
 *  verbruikt dat token per voorstel (WF-40), dus wat intussen al is afgehandeld wordt
 *  overgeslagen en geteld.
 */
export async function beslisGroep(ids, besluit) {
  const { data } = await axios.post(`${API}/postbus/geheugen-groep/toon`, { ids });
  const r = await axios.post(`${API}/postbus/geheugen-groep/${besluit}`, { ids, token: data.token });
  return r.data;
}

/** De open groepen in de lijst, met hun voorstel-id's. PUUR. */
/** Glasronde 0.9.246 0c (Frank, 5 nov): een voorstel waarvan "Blijft" of "Gaat weg" niet leesbaar is, doet nooit mee
 *  in Alles vervangen of Selectie vervangen. De backend toont zulke voorstellen niet meer; dit is de tweede grendel. */
export const leesbaar = (v) => Boolean(v && typeof v.houd === "string" && v.houd.trim()
  && typeof v.weg === "string" && v.weg.trim());

export function openGroepen(berichten) {
  return (berichten || []).filter((b) => b.geheugen_groep).map((b) => ({
    id: b.id,
    ids: b.geheugen_groep.ids.filter((_, i) => leesbaar((b.geheugen_groep.voorstellen || [])[i])),
  })).filter((g) => g.ids.length > 0);
}
